///
/// EarthBrowser
///
/// Migration v43 to v44: Add persisted bottom drawer active tab
/// Created by Matt Giger on September 16, 2026
/// Copyright (c) 2026 Geodata Labs
///

interface BottomDrawerV43 {
	activeTabId?: string | null
}

interface UserInterfaceV43 {
	bottomDrawer?: BottomDrawerV43
}

interface StateV43 {
	userInterface?: UserInterfaceV43
}

/**
 * Migration: v43 to v44
 *
 * Changes:
 * - Adds bottomDrawer.activeTabId (default: null) so the selected drawer
 *   tab is preserved between launches
 */
export function migrateV43toV44(state: unknown): unknown {
	if (!state) return state

	const newState = { ...(state as StateV43) }

	if (newState.userInterface?.bottomDrawer) {
		const drawer = newState.userInterface.bottomDrawer
		newState.userInterface = {
			...newState.userInterface,
			bottomDrawer: {
				...drawer,
				activeTabId: drawer.activeTabId ?? null,
			},
		}
	}

	return newState
}
